import {
  DepartmentOutline,
  Globe2Outline,
  LargeBuilding,
  LargeGlobe,
  LargePeople,
  LargePerson,
  PeopleOutline,
  PersonOutline,
} from '@lyearn/icons';
import { ObjectiveTypeEnum, OkrCycleSubjects } from '@/types/schema';

export const OBJECTIVE_TYPE_CONFIG = {
  [ObjectiveTypeEnum.Company]: {
    value: ObjectiveTypeEnum.Company,
    Icon: Globe2Outline,
    LargeIcon: LargeGlobe,
    labelKey: 'Common:ObjectiveType.Company',
    subject: OkrCycleSubjects.CompanyObjective,
  },
  [ObjectiveTypeEnum.Department]: {
    value: ObjectiveTypeEnum.Department,
    Icon: DepartmentOutline,
    LargeIcon: LargeBuilding,
    labelKey: 'Common:Filter.Department',
    subject: OkrCycleSubjects.DepartmentObjective,
  },
  [ObjectiveTypeEnum.Team]: {
    value: ObjectiveTypeEnum.Team,
    Icon: PeopleOutline,
    LargeIcon: LargePeople,
    labelKey: 'Common:ObjectiveType.Team',
    subject: OkrCycleSubjects.TeamObjective,
  },
  [ObjectiveTypeEnum.Individual]: {
    value: ObjectiveTypeEnum.Individual,
    Icon: PersonOutline,
    LargeIcon: LargePerson,
    labelKey: 'Common:ObjectiveType.Individual',
    subject: OkrCycleSubjects.IndividualObjective,
  },
};
